// extracted by mini-css-extract-plugin
export default {"cls1":"ConfirmPayoutError-Callout_cls1__sAROL","cls2":"ConfirmPayoutError-Callout_cls2__WUtkm ConfirmPayoutError-Callout_cls1__sAROL"};